export function maskLmVRID(lmVRID) {

    const date = lmVRID.split(hyphenSeparator)[0]
    const hour = lmVRID.split(hyphenSeparator)[1]
    const vehicleNumber = lmVRID.split(hyphenSeparator)[2]

    const maskedVehicleNumber = maskVehicleNumber(vehicleNumber)
    const maskedLmVRID = date + hyphenSeparator + hour + hyphenSeparator + maskedVehicleNumber;
    return maskedLmVRID;

}

export function getCSVdata(lmVRIDs) {
   const  maskedLmVRIDList = [];
    var itr = 0;
   while (itr < lmVRIDs.length) {
       let lmVRID = lmVRIDs[itr];
       const lmVRIDDetailsRecord = {};
       lmVRIDDetailsRecord.LMVRID = maskLmVRID(lmVRID.LMVRID);
       lmVRIDDetailsRecord.LAST_UPDATED_TIME = lmVRID.LAST_UPDATED_TIME ;
       lmVRIDDetailsRecord.CREATION_TIME = lmVRID.CREATION_TIME ;
       lmVRIDDetailsRecord.LAST_UPDATED_BY = lmVRID.LAST_UPDATED_BY ;
       lmVRIDDetailsRecord.PACKAGE_BARCODES = lmVRID.PACKAGE_BARCODES ;

       maskedLmVRIDList.push(lmVRIDDetailsRecord);
       itr++;
    }
    return maskedLmVRIDList;
}

function maskVehicleNumber(vehicleNumber) {
const vehicleNumberLength = vehicleNumber.length;
const vehicleNumberPrefix = vehicleNumber.substring(0, prefixCharCount);
const vehicleNumberSuffix = vehicleNumber.substring(vehicleNumberLength - trailingCharIntactCount, vehicleNumberLength);

const maskedVehicleNumber = vehicleNumberPrefix + maskingCharacter.repeat(vehicleNumberLength - trailingCharIntactCount - prefixCharCount)
    + vehicleNumberSuffix;

return maskedVehicleNumber;

}

 const maskingCharacter = "*"
const hyphenSeparator = "-"
const prefixCharCount = 2;
const trailingCharIntactCount = 4;


// WEBPACK FOOTER //
// ./src/components/util/EwayBillUtils.js